import { Avatar, Box, BoxProps } from "@mui/material";

import { DropzoneFileItem } from "../../types";
import FileInfo from "../FileInfo/file-info";

import type { JSX } from "react";

type DropzoneFileProps = BoxProps & {
  file: DropzoneFileItem;
  icon?: React.ReactNode;
  onFileDownload?: (file: DropzoneFileItem) => void;
  avatarIcon?: React.ReactNode;
  downloadDisabled?: boolean;
};

const DropzoneFile = ({
  file,
  icon,
  onFileDownload,
  avatarIcon,
  downloadDisabled,
  ...rest
}: DropzoneFileProps): JSX.Element => (
  <Box
    data-testid="ds-dropzone-file"
    p={2}
    display="flex"
    justifyContent="space-between"
    alignItems="center"
    gap={2}
    {...rest}
  >
    {avatarIcon ? (
      <Avatar
        data-testid="ds-avatar"
        sx={{ bgcolor: "white", color: "brandSupporting.main" }}
      >
        {avatarIcon}
      </Avatar>
    ) : null}
    <FileInfo
      file={file}
      downloadDisabled={downloadDisabled}
      onFileDownload={onFileDownload ? () => onFileDownload(file) : undefined}
    />
    {icon ?? null}
  </Box>
);

export default DropzoneFile;
